const initialState = {
    refDataPurgeProcess: [],
    refDataPurgeConfigs: []
};
export default initialState;